import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './admin.module.scss';
import {adminRun} from './admin.route';
import {AdminViewComponentConfig} from './component/adminView/adminView';
import {KonfigurationViewComponentConfig} from './component/konfigurationView/konfigurationView';
import {MigrationViewComponentConfig} from './component/migrationView/migrationView';
import {MigrationRS} from './service/MigrationRS.rest';
import {TestFaelleRS} from './service/testFaelleRS.rest';

export const SerfWebAdmin = angular.module('serfWeb.admin', [SerfWebCore.name, 'smart-table', 'ui.bootstrap'])
    .service('TestFaelleRS', TestFaelleRS)
    .service('MigrationRS', MigrationRS)
    .component('dvAdminView', new AdminViewComponentConfig())
    .component('dvKonfigurationView', new KonfigurationViewComponentConfig())
    .component('dvMigrationView', new MigrationViewComponentConfig())
    .run(adminRun);

export default SerfWebAdmin;



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts